module.exports = __webpack_public_path__ + "img/home-service-ht.ea1c0260.png";